import templateUrl from './modified-time-entries.component.html'

export const DashboardModifiedTimeEntriesComponent = {
    bindings: {
        modifiedTimeEntries: "<",
        acknowledge: "&onAcknowledge",
        acknowledgeAll: "&onAcknowledgeAll",
        onShowDetails: "&onShowDetails"
    },
    controller: class DashboardModifiedTimeEntriesController {
        constructor() {
            this.pageSize = 6;
            this.pageNumber = 1;
        }
    },
    controllerAs: "vm",
    bindToController: true,
    templateUrl
};
